<template>
  <div class="category category_searchtab-title">
    <div class="categolies__radio">
      <el-radio v-model="cateRadio" v-removeAria label="bmRadio"><span class="category_searchtab-title">{{$t('T_BUSINESS_MODEL')}}</span>
      </el-radio>
      <el-radio v-model="cateRadio" v-removeAria label="htmRadio" :disabled="htWorkFlag"><span class="category_searchtab-title">{{$t('T_HOME_MODEL')}}</span></el-radio>
    </div>
    <div class="categolies__select">
      <div class="category-select">
        <div class="label">
          <label>{{$t('T_CATEGORY')}}</label>
        </div>
        <div class="label-select">
          <div v-if="cateRadio === 'bmRadio'">
            <el-select v-model="cateValue" @change="onBusinessCateChange" class="category_select_searchtab-title">
              <div>
              <el-option v-for="item in businessModelOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
              </el-option>
              </div>
            </el-select>
          </div>
          <div v-else-if="ProjectorSpec[0].isMainPSConfig === 1">
            <el-select v-model="htmCateValue" @change="onHomeCateChange" class="category_select_searchtab-title">
              <el-option v-for="item in homeModelOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div v-else>
            <el-select :disabled="true" v-model="disableValue" class="category_select_searchtab-title">
            </el-select>
          </div>
        </div>
      </div>
      <div class="model-select">
        <div class="label">
          <label>{{$t('T_MODEL')}}</label>
        </div>
        <div class="label-select">
          <div v-if="cateRadio === 'bmRadio'">
            <el-select v-model="bmSelectedModel" @change="onBmModelChange" class="category_select_searchtab-title">
              <el-option v-for="(item, index) in bmMatchingModelDataSort" :key="index" :value="item.name"
                :label="getModelLabel(item.name)"></el-option>
            </el-select>
          </div>
          <div v-else>
            <el-select v-model="htmSelectedModel" @change="onHtmModelChange" class="category_select_searchtab-title">
              <el-option v-for="(item, index) in htmMatchingModelDataSort" :key="index" :value="item.name"
                :label="getModelLabel(item.name)"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="option-select">
        <div class="label">
          <label>{{$t('T_OPTION_LENS')}}</label>
        </div>
        <div class="label-select">
          <div v-if="cateRadio === 'bmRadio'">
            <el-select v-model="bmSelectedLens" @change="onBmLensChange" class="category_select_searchtab-title" :disabled="bmMatchingLensID && bmMatchingLensID.length ? false : true">
              <el-option v-for="(item, index) in bmMatchingLensIDSort" :key="index" :value="item.id" :label="item.name">
              </el-option>
            </el-select>
          </div>
          <div v-else>
            <el-select :disabled="true" v-model="disableValue" class="category_select_searchtab-title">
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'categoryTab',
  data () {
    return {
      businessModelOptions: [
        {
          value: 0,
          label: 'T_CATEGORY_SELECT_1'
        },
        {
          value: 1,
          label: 'T_CATEGORY_SELECT_2'
        },
        {
          value: 2,
          label: 'T_CATEGORY_SELECT_3'
        },
        {
          value: 3,
          label: 'T_CATEGORY_SELECT_4'
        },
        {
          value: 4,
          label: 'T_CATEGORY_SELECT_5'
        }
      ],
      homeModelOptions: [],
      bmSelectedModel: '',
      bmSelectedLens: '',
      htmSelectedModel: '',
      htmSelectedLens: '',
      disableValue: ' - - - ',
      htmCateValue: 6,
      htWorkFlag: false
    }
  },
  props: ['searchTabActiveName'],
  computed: {
    ...mapState(['selectedModelData',
      'bmMatchingModelData', 'bmSelectedModelData', 'bmMatchingLensID', 'bmSelectedLensData',
      'htmMatchingModelData', 'htmSelectedModelData', 'htmSelectedLensData',
      'cateRadio', 'cateValue', 'searchTabActive'
    ]),
    cateRadio: {
      get () {
        return this.$store.state.cateRadio
      },
      set (val) {
        this.CATERADIO(val)
      }
    },
    cateValue: {
      get () {
        return this.$store.state.cateValue
      },
      set (val) {
        this.CATEVALUE(val)
      }
    },

    bmMatchingModelDataSort () {
      return this.$commonJs.dataSort(this.bmMatchingModelData, 'name')
    },

    htmMatchingModelDataSort () {
      return this.$commonJs.dataSort(this.htmMatchingModelData, 'name')
    },

    bmMatchingLensIDSort () {
      return this.$commonJs.dataSort(this.bmMatchingLensID, 'name')
    }
  },
  watch: {
    cateRadio (val) {
      this.CATERADIO(val)
      this.upDateData()
    },
    searchTabActive (val) {
      if (val === 'Categolies') {
        this.upDateData()
      }
    },
    bmSelectedModelData (value) {
      this.bmSelectedModel = value ? value.name : this.disableValue
    },
    htmSelectedModelData (value) {
      this.htmSelectedModel = value ? value.name : this.disableValue
    },
    bmSelectedLensData (value) {
      if (value) {
        this.bmSelectedLens = value.id ? value.id : this.disableValue
      }
    }
  },

  methods: {
    ...mapMutations([
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA',
      'BMMATCHINGMODELDATA', 'BMSELECTEDMODELDATA', 'BMMATCHINGLENSID', 'BMSELECTEDLENSDATA',
      'HTMMATCHINGMODELDATA', 'HTMSELECTEDMODELDATA', 'HTMSELECTEDLENSDATA',
      'CATERADIO', 'CATEVALUE'
    ]),
    upDateData () {
      if (this.cateRadio === 'bmRadio') {
        this.MATCHINGMODELDATA(this.bmMatchingModelData)
        this.SELECTEDMODELDATA(this.bmSelectedModelData)
        this.MATCHINGLENSID(this.bmMatchingLensID)
        this.SELECTEDLENSDATA(this.bmSelectedLensData)
      } else {
        this.MATCHINGMODELDATA(this.htmMatchingModelData)
        this.SELECTEDMODELDATA(this.htmSelectedModelData)
        this.MATCHINGLENSID()
        this.SELECTEDLENSDATA(this.htmSelectedLensData)
      }
    },
    onBmModelChange (value) {
      let bmSelectedModelData = this.bmMatchingModelData.find(item => item.name === value)
      this.SELECTEDMODELDATA(bmSelectedModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)
      this.MATCHINGLENSID(bmLensData.matchingLensID)
      this.SELECTEDLENSDATA(bmLensData.selectedLensInfo)
    },
    onHtmModelChange (value) {
      let htmSelectedModelData = this.htmMatchingModelData.find(item => item.name === value)
      this.SELECTEDMODELDATA(htmSelectedModelData)
      this.HTMSELECTEDMODELDATA(htmSelectedModelData)
      let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
      this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
      this.SELECTEDLENSDATA(htmLensData.selectedLensInfo)
    },
    findMatchingLensAndSelectedLensData (model) {
      return this.$commonJs.findLensInfo(model)
    },
    onBusinessCateChange (val) {
      let matchingModel = null
      if (this.ProjectorSpec[0].isMainPSConfig === 1) {
        matchingModel = this.$commonJs.findMatchingModelByConf(val)
      } else {
        switch (val) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            matchingModel = this.$commonJs.findMatchingModel(val)
            break
          default:
            matchingModel = this.ProjectorSpec
        }
      }
      if (matchingModel.length === 0) {
        this.bmSelectedModel = this.disableValue
        this.BMMATCHINGMODELDATA('')
        return
      }
      let bmMatchingModelData = matchingModel
      let bmSelectedModelData = matchingModel[0]
      this.bmSelectedModel = bmSelectedModelData ? bmSelectedModelData.name : this.disableValue
      this.SELECTEDMODELDATA(bmSelectedModelData)
      this.MATCHINGMODELDATA(bmMatchingModelData)

      this.BMMATCHINGMODELDATA(bmMatchingModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)

      this.MATCHINGLENSID(bmLensData.matchingLensID)
      this.SELECTEDLENSDATA(bmLensData.selectedLensInfo)
    },
    onBmLensChange (value) {
      let data = this.$commonJs.findLensDataByIdAndSize(value, this.selectedModelData.lcdSize)
      this.SELECTEDLENSDATA(data)
      this.BMSELECTEDLENSDATA(data)
    },
    initBmValue () {
      let bmMatchingModelData
      if (this.ProjectorSpec[0].isMainPSConfig === 1) {
        for (let i = 0; i < 6; i++) {
          bmMatchingModelData = this.$commonJs.findMatchingModelByConf(i)
          if (bmMatchingModelData !== undefined && bmMatchingModelData.length !== 0) {
            this.CATEVALUE(i)
            break
          }
        }
      } else {
        bmMatchingModelData = this.$commonJs.findMatchingModel(0)
      }
      let bmSelectedModelData = bmMatchingModelData[0]
      this.bmSelectedModel = bmSelectedModelData.name || this.disableValue
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGMODELDATA(bmMatchingModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)
      this.initCateGory()
    },
    initCateGory () {
      // businessModelOptions
      if (this.ProjectorSpec[0].isMainPSConfig === 1) {
        let c5 = this.ProjectorSpec.filter(item => {
          return item.c5 && item.c5 === true
        })
        let v = this.ProjectorSpec[0].categoliesBm.split(',')
        if (c5.length === 0) v = v.splice(0, v.length - 1)
        let cas = []
        for (let i = 0; i < v.length; i++) {
          let ca = {}
          switch (v[i]) {
            case 'Standard / Classroom / Mobile model':
              ca.label = 'T_CATEGORY_SELECT_1'
              break
            case 'Short Throw / Ultra Short Throw model':
              ca.label = 'T_CATEGORY_SELECT_2'
              break
            case 'Signage / Lighting model':
              ca.label = 'T_CATEGORY_SELECT_3'
              break
            case 'High Brightness model(Lens fixed)':
              ca.label = 'T_CATEGORY_SELECT_4'
              break
            case 'High Brightness model(with optional lenses)':
              ca.label = 'T_CATEGORY_SELECT_5'
              break
            default:
              ca.label = v[i]
          }
          ca.value = i
          if (v[i]) {
            cas.push(ca)
          }
        }
        this.businessModelOptions = cas
        let hv = this.ProjectorSpec[0].categoliesHtm.split(',')
        let c7 = this.ProjectorSpec.filter(item => {
          return item.c7 && item.c7 === true
        })
        let c8 = this.ProjectorSpec.filter(item => {
          return item.c8 && item.c8 === true
        })
        if (c7.length === 0) hv[1] = ''
        if (c8.length === 0) hv[2] = ''
        let hcas = []
        for (let i = 0; i < hv.length; i++) {
          if (!hv[i]) continue
          let ca = {}
          ca.label = hv[i]
          ca.value = i + 6
          if (hv[i]) {
            hcas.push(ca)
          }
        }
        this.homeModelOptions = hcas
      }
    },
    onHomeCateChange (val) {
      let htmMatchingModelOptions = this.$commonJs.findMatchingModelByConf(val)
      if (htmMatchingModelOptions.length === 0) {
        this.htmSelectedModel = this.disableValue
        this.HTMMATCHINGMODELDATA('')
        return
      }
      let htmSelectedModelData = htmMatchingModelOptions[0]
      if (htmSelectedModelData) {
        this.htmSelectedModel = htmSelectedModelData.name
        let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
        this.HTMMATCHINGMODELDATA(htmMatchingModelOptions)
        this.HTMSELECTEDMODELDATA(htmSelectedModelData)
        this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
        this.onHtmModelChange(htmSelectedModelData.name)
      }
    },
    initHtmValue () {
      let htmMatchingModelOptions
      if (this.ProjectorSpec[0].isMainPSConfig === 1) {
        htmMatchingModelOptions = this.$commonJs.findMatchingModelByConf(6)
        let htmMatchingModelOption7 = this.$commonJs.findMatchingModelByConf(7)
        let htmMatchingModelOption8 = this.$commonJs.findMatchingModelByConf(8)
        if (htmMatchingModelOptions.length === 0 && htmMatchingModelOption7.length === 0 && htmMatchingModelOption8.length === 0) {
          this.htWorkFlag = true
        }
      } else {
        htmMatchingModelOptions = this.$commonJs.findMatchingModel(5)
      }
      let htmSelectedModelData = htmMatchingModelOptions[0]
      if (htmSelectedModelData) {
        this.htmSelectedModel = htmSelectedModelData.name
        let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
        this.HTMMATCHINGMODELDATA(htmMatchingModelOptions)
        this.HTMSELECTEDMODELDATA(htmSelectedModelData)
        this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
      }
    },
    getModelLabel (label) {
      return this.$commonJs.getModelLabelByName(label)
    }
  },

  mounted () {
    this.initBmValue()
    this.initHtmValue()
    if (this.searchTabActiveName === 'Categolies') {
      this.upDateData()
    }
  }
}
</script>

<style scoped>
.category_searchtab-title {
  font-size: 12px;
}

.categolies__radio{
  height: 45px;
  line-height: 45px;
  padding-left: 20px;
  border-right: 2px solid #bdbdbd;
  border-bottom: 1px solid #d3d3d3;
}

.categolies__select {
  height: 45px;
  padding-left: 20px;
  border-right: 2px solid #bdbdbd;
}

.category-select {
  width: 390px;
  float: left;
}

.model-select {
  width: 373px;
  float: left;
}

.label {
  float: left;
  line-height: 45px;
}

.label-select {
  width: 320px;
  float: left;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/tabs/categoryTab.vue